import React, { useContext, useState, useEffect } from "react";
import { Grid, Row, Col } from "react-bootstrap";
import { Modal } from 'react-bootstrap';
import ButtonField from '../components/UI/Button/ButtonField';
import { PostAPI } from "api/post";
import { useTranslation } from 'react-i18next';
import swal from 'sweetalert';
import { FeatureBlueprintContext } from "context/FeatureBlueprintContext";
import { GlobalLoadIndicator } from "context/GlobalLoadIndicator";
import BeatLoader from "react-spinners/BeatLoader";
import Step1 from "components/Steps/Step1";
import Step2 from "components/Steps/Step2";
import Step3 from "components/Steps/Step3";
import useValidator from '../hooks/useValidator';
import { WizardDataContext } from "context/WizardDataContext";
import { customStep } from "../constants/staticVariables";
import 'assets/css/custom.css';
import Cookies from 'universal-cookie';
const cookies = new Cookies();
let urlhost = window.location.host;
let urlprotocol = window.location.protocol;
let completeURL = urlprotocol + "//" +urlhost;


const RoleWizard = props => {
  const {setHasError} = props;
  const { t } = useTranslation();
  const [wizardData] = useContext(WizardDataContext)
  let [currentStep, setcurrentStep] = useState(1);
  let [duplicateCheck, setDuplicateCheck] = useState(false);
  let [parentTableLength, setParentTableLength] = useState();
  let Components = {
    step1: Step1,
    step2: Step2,
    step3: Step3,
  };
  let [disabledButton, setDisabledButton] = useState(false);
  // let savebtnRef = useRef(null);
  let [formValues, setFormValues] = useState([]);
  let [tdDataParent, setTdDataParent] = useState([]);
  let [selectChildValueCheckbox, setSelectChildValueCheckbox] = useState([]);
  let [selectChildValueCheckboxExpanded, setSelectChildValueCheckboxExpanded] = useState([]);
  let [selectChildValue, setSelectChildValue] = useState([]);
  const [validator, showValidationMessage] = useValidator();
  const [showModal, setshowModal] = useState(false);
  let [imageBinary, setImageBinary] = useState({});
  let [imageData, setImageData] = useState();
  let [imageSize, setImageSize] = useState();
  let [selectedCombo,setSelectedCombo] = useState();
  let [isLoader, setIsLoader] = useState(false)
  const [page,setPage] = useState();    
  let arrayConvert = []
  let arrayConvert1 = [];
  let arrayConvert2 = [];
  const currentLanguageCode = localStorage.getItem('i18nextLng') || 'english'
  const language = currentLanguageCode === 'en' ? 'english' : 'chinese'
  let dynamicParameters = {
    user_id:cookies.get('user_id'),
    customer_id:cookies.get('customer_id'),
    language:language
  }
  
  // const openLocation = () => {
  //   setmodalType('Add');
  //   setmodalTitle(props.pageLayoutData1.addButtonName1);
  //   setModalWidth(props.pageLayoutData1.addButtonItems1.className);
  //   setModalformValues(props.pageLayoutData1.addButtonItems1.formValues)
  //   setmodalActionURL(props.pageLayoutData1.addButtonItems1.apiEndPointLocation)
  //   setshowModal(true);
  // }
  // const openBusinessUnit = () => {
  //   setmodalType('Add');
  //   setmodalTitle(props.pageLayoutData1.addButtonName2);
  //   setModalWidth(props.pageLayoutData1.addButtonItems2.className);
  //   setModalformValues(props.pageLayoutData1.addButtonItems2.formValues)
  //   setmodalActionURL(props.pageLayoutData1.addButtonItems2.apiEndPointBussinessUnit)
  //   setshowModal(true);
  // }
  // const openUOM = () => {
  //   setmodalType('Add');
  //   setmodalTitle(props.pageLayoutData1.addButtonName3);
  //   setModalWidth(props.pageLayoutData1.addButtonItems3.className);
  //   setModalformValues(props.pageLayoutData1.addButtonItems3.formValues)
  //   setmodalActionURL(props.pageLayoutData1.addButtonItems3.apiEndPointUOM)
  //   setshowModal(true);
  // }
  const onTop = () => {
    window.scrollTo(0, 0);
  }

  useEffect(() => {
    onTop()
  }, [page]);

  useEffect(() => {
    if (Object.hasOwn(wizardData, 'productsView') && "custom_fields" in wizardData?.productsView?.data) {
      if (Object.keys(wizardData?.productsView?.data?.custom_fields).length > 0) {
        if (props.pageLayoutData.content.steps.length > 0) {
          customStep.formValues = {
            ...wizardData?.productsView?.data?.custom_fields
          }
          customStep.id = `Step${props.pageLayoutData.content.steps.length + 1}`
          customStep.step = props.pageLayoutData.content.steps.length + 1
          customStep.flag = true
          props.pageLayoutData.content.steps.push(customStep);
        }
      }
    }
    return () => {
      if (props.pageLayoutData.content.steps[props.pageLayoutData.content.steps?.length - 1].id === customStep.id) {
        props.pageLayoutData.content.steps.pop();
      }
    }
  }, [])

  const close = () => {
    setshowModal(false);
  }

  const handleChildValueCheckbox = (clicked) => {
    setSelectChildValueCheckbox(clicked);
  }

  const handleChildValueCheckboxExpanded = (expanded) => {
    setSelectChildValueCheckboxExpanded(expanded);
  }

  const handleChildValueSelect = (val) => {
    setSelectChildValue(val);
  }
  
  const _next = () => {
  try {
      
      // if(props.commonTitle === 'Company'){
      //   if(currentStep == 1){
      //     setCStep1(formValues);
      //   }else if(currentStep == 2){
      //     setCStep2(formValues);
      //   }else if(currentStep == 3){
      //     setCStep3(formValues);
      //   }
      // }
      if (currentStep == 4 && parentTableLength == 0) {
        
        swal("Add Table is Mandatory", "Please add level", "warning") 
       // setloadSForm(false);
        }
      else if (validator.allValid()) {
       
      let currentStep1 = currentStep;
      currentStep1 = currentStep1 >= ((Object.keys(props.pageLayoutData.content.steps).length)-1)? (Object.keys(props.pageLayoutData.content.steps).length): currentStep1 + 1
      setcurrentStep(currentStep1); 
      }else if((currentStep == 4 && duplicateCheck === true)){
        let currentStep1 = currentStep;
        currentStep1 = currentStep1 >= ((Object.keys(props.pageLayoutData.content.steps).length)-1)? (Object.keys(props.pageLayoutData.content.steps).length): currentStep1 + 1
        setcurrentStep(currentStep1); 
      }else if((currentStep == 4 && duplicateCheck === false)){
        showValidationMessage(true);
      }
      else{
        showValidationMessage(true);
      }
  } catch (error) {
    setHasError({
      error: true,
      message: error
    })
  }
  }
  
  const _prev = () => {
    let currentStep1 = currentStep
    currentStep1 = currentStep1 <= 1? 1: currentStep1 - 1
    setcurrentStep(currentStep1);
  }

  const previousButton = () => {
    let currentStep1 = currentStep;
    if(currentStep1 !==1){
      return (
        <ButtonField submit={_prev} color="danger" BName={`${t('previous')}`} />
      )
    }
    return null;
  }

  const nextButton = () => {
    try {
      let currentStep1 = currentStep;
      if(currentStep1 < (Object.keys(props.pageLayoutData.content.steps).length)){
        return (
          <ButtonField submit={_next} color="info" BName={`${t('next')}`} />     
        )
      }
      return(
        <ButtonField
        //ref="savebtnRef"
        disabled={disabledButton}
        color="info"
        submit={ (e) => wizardSave(e)}
        BName={`${t('save')}`}/>
        // <ButtonField color="danger" 
        // ref="savebtnRef"
        //   submit={wizardSave}
        //   BName="Save"
        // /> 
      )
    }catch(error) {
      setHasError({
        error: true,
        message: error
    })
    }
  }

  const backFunction = e =>
  {
    // backCheck = 1;
   // props.setBackCheck(true);
    props.setShowParentContent(true);
    setFormValues([]);
    setSelectChildValueCheckbox([]);
    setSelectChildValueCheckboxExpanded([]);
    setSelectChildValue([]);
    setTdDataParent([]);
  }
  const wizardSave = async (e) => {
    try{
    e.preventDefault();
      if (currentStep == 3 && parentTableLength == 0 && props.wizardTitle === "Product") {
        swal("Add Table is Mandatory", "Please add level", "warning")
      }
    setIsLoader(true);
    //setDisabledButton(true);
    // if(savebtnRef.current)
    // savebtnRef.current.setAttribute("disabled", "disabled");
  if (validator.allValid()) {
    setDisabledButton(true);
    let wizard = {
      formValues: formValues,
      tdDataParent: tdDataParent,
      selectChildValueCheckbox: selectChildValueCheckbox,
      selectChildValue: selectChildValue
    };

    let requestData = '';
    let formData;

    if(formValues?.location)
    {
      if(formValues?.location !== null && formValues?.location[0]?.value !== undefined ){
        formValues.location.map(function(fValue, indexId){
        arrayConvert1[indexId] = fValue.value;
      });
      formValues.location = arrayConvert1;
    }
  }
  if(Object.hasOwn(formValues,'warranty_period')){
    formValues.warranty_period = +formValues?.warranty_period ?? 0
  }
  if(formValues?.category){
    if(props.pageLayoutData.content.steps[1].formValues?.category["elementType"] === 'selectshowsearch'){
      let arrOfObj1 = Object.entries(formValues.category).map(entry => entry[1])
      formValues.category = arrOfObj1[0].toString()
      }
  }
  if (formValues.hasOwnProperty('component')) {
    if( (cookies.get("customer_id") != 17 && cookies.get("customer_id") != 5) && (formValues['product_type']==='8003' || formValues['product_type']==='8001')){
    formValues.component=null
    }
    else if (formValues?.component !== null && (selectedCombo?.visible === false)) {
      if (formValues?.component !== null) {
        formValues.component.map(function (fValue, indexId) {
          arrayConvert2[indexId] = Object.hasOwn(fValue, 'value') ? fValue.value : fValue;
        });
        formValues.component = arrayConvert2;
      }
    }
}
    if(selectChildValue)
    {
      selectChildValue.forEach(function(fValue, indexId){
             arrayConvert[indexId] = fValue.value;
           });
      selectChildValue = arrayConvert;
    }
    // if(imageData)
    // {
    //   formData = new FormData(); 
    //   formData.append( 
    //     "file", 
    //     imageData
    //   ); 
    // }
   
    let combined = selectChildValueCheckbox.concat(selectChildValueCheckboxExpanded)
    let combinedUnique = combined.filter((item, pos) => combined.indexOf(item) === pos)
    let extraParameters = {
      feature_ids: combinedUnique,
      feature_ids_checked: selectChildValueCheckbox,
      feature_ids_expanded: selectChildValueCheckboxExpanded,
      assigned_users_id: arrayConvert,
      tbData:tdDataParent,
      created_from:'Website',
      customer_type:cookies.get('customer_id'),
      img: imageData,
      filename: imageBinary,
      filesize: imageSize,
      url: completeURL
    } 
    
    if (props.wizardTitle === 'Products'  && cookies.get('customer_id') === '12') {
      let wizardFormValues = props.pageLayoutData.content.steps.reduce((acc, el, index, arr) => {
        acc.push(el.formValues)
        return acc
      }, [])

      for (let formValue of wizardFormValues) {
        Object.keys(formValue).forEach((item) => {
          if (formValue[item].elementType === 'checkbox') {
            if (formValues[item]) {
              formValues[item] = 1
            } else {
              formValues[item] = 0
            }
          }
        })
      }
    }

    if (props.wizardTitle === 'Role') {
       if(Object.hasOwn(formValues,'active')){
          if (Boolean(formValues['active'])) {
              formValues['active'] = cookies.get("customer_id") === '12' ? "1" : 1
            } else {
              formValues['active'] = cookies.get("customer_id") === '12' ? "0" : 0
            }
          }
    }
    const customField = {}
    if(wizardData?.productsView?.data?.custom_fields){
      const activeCustomFields = Object.keys(wizardData?.productsView?.data?.custom_fields)
      activeCustomFields.forEach(fieldKey => {
          customField[fieldKey] = formValues[`${fieldKey}`]
      })
    }
    if(props.commonTitle === "Product" || props.titlePreFix === `${t("edit")}`){
      requestData = {...formValues, ...dynamicParameters,
        extraParameters, id:props.uniqueId, formData,customField}
      }else{
      requestData = {...formValues, ...dynamicParameters,
        extraParameters,customField}
    }
    // if(props.commonTitle === 'Role'){
    //   let assingUser = [];
    //   selectChildValue.map(function(fValue, indexId){
    //     assingUser[indexId] = fValue.value;
    //   });
      
    //   requestData = {
    //     role_id: (props.titlePreFix === 'Add') ? 0 : formValues.inheritRoles, 
    //     name: formValues.name,
    //     description: formValues.description,
    //     is_active: formValues.is_active,
    //     assigned_users_id: assingUser,
    //     feature_ids: selectChildValueCheckbox,
    //     user_id: cookies.get('user_id'),
    //     manufacturer_id: cookies.get('customer_id'),
    //     customer_type:cookies.get('customer_type')
    //   }
    // }

    // if(props.commonTitle === 'Company'){
    //   requestData = { ...CStep1, ...CStep2, ...CStep3};
    // }
    // if(props.commonTitle === 'Product'){
    //   if(formValues.location)
    //   {
    //    formValues.location.map(function(fValue, indexId){
    //          arrayConvert[indexId] = fValue.value;
    //        });
    //      formValues.location = arrayConvert;
    //    }
    //   }
    //     if(props.titlePreFix == 'Edit') {
    //       requestData = { ...formValues,
    //         tbData:tdDataParent,
    //         user_id: cookies.get('user_id'),
    //         customer_id: cookies.get('customer_id'),product_id:props.productId};
    //     }
    //     else
    //     {
    //   requestData = { ...formValues,
    //     tbData:tdDataParent,
    //     user_id: cookies.get('user_id'),
    //     customer_id: cookies.get('customer_id'),created_from:'Website'};
    //     }
    //   }
    let url = props.addURL;
    PostAPI(url, requestData)
      .then(res => {
        if (res.status == 200){
          setIsLoader(false)
          if(res.data.data.status == 409) {
            swal(res.data.data.message, {
                icon: "error",
                timer: 2000,
                button: false
            });
            setDisabledButton(false);
          } else {
          swal({
            title: `${t("alerts.successfully_submitted")}`,
            icon: "success",
            timer: 2000,
            button: false
          })
          setDisabledButton(true);
          // this.refs.btnSave.removeAttribute("disabled");
          setTimeout(() => {
            props.recallMethod();
          }, 1000);

          setFormValues([]);
          setSelectChildValueCheckbox([]);
          setSelectChildValueCheckboxExpanded([]);
          setSelectChildValue([]);
          setTdDataParent([]);
          props.setShowParentContent(true);
         }
        }
        else {
          swal({
            title: "Not Success!",
            icon: "error",
            timer: 1000,
            button: false
          })
          setDisabledButton(false);
        }

      }).catch(function (error) {
        setHasError({
          error: true,
          message: error
        })
      });
    }
    else
    {
      setIsLoader(false)
      showValidationMessage(true);
    }
  }catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
  }

  return (
  (props.pageLayoutData != 'undefined') ?
    <div className="content">
    <Grid fluid>
      <Row>
        <Col md={12} style={{backgroundColor:'#fbfbfb'}}>
        <div className="wizard-modal">
        {(!props.showParentContent) ?
        <span className="close-icon-custom" onClick={backFunction}>
                <i className="fa fa-window-close" aria-hidden="true"></i>
            </span> : ""}
        <Modal.Header>
                <Modal.Title>
                  {t(props.titlePreFix) }
                 <span className='wizard-title'>
                    {t(props.wizardTitle)}
                  </span>
                </Modal.Title>
              </Modal.Header>

              <ul className="breadcrumb" style={{marginLeft:'5px',marginBottom:'5px',marginTop:'10px'}}>       
                {props.pageLayoutData.content.steps.map(function(element, indexIdx){
                  return (
                    <li key={indexIdx} value={indexIdx}><a href="#" 
                    className={(currentStep===indexIdx+1)?'step-active':''}
                    >{t(element.id)}</a></li> 
                  );
                })}   
              </ul>
                 
                <Modal.Body>
               
                {props.pageLayoutData.content.steps.map(block =>(
                  (typeof Components[block.component] != "undefined") ?
                    React.createElement(Components[block.component], {
                      
                      key: block.id,
                      block: block,
                      titlePreFix:props.titlePreFix,
                      getDataURL:props.getURL,
                      futurename: props.featureName,
                      updtPageURL: props.updatePageDataURL,
                      currentStep: currentStep,
                      dropDwnApi: props.dropDwnApi,
                      setFormValues: setFormValues,
                      formValues: { ...formValues},
                      setTdDataParent: setTdDataParent,
                      tdDataParent: tdDataParent,
                      checkboxcheck: handleChildValueCheckbox,
                      checkboxexpand: handleChildValueCheckboxExpanded,
                      selectChildValueCheckbox: selectChildValueCheckbox,
                      setSelectChildValueCheckbox: setSelectChildValueCheckbox,
                      setSelectChildValue:setSelectChildValue,
                      selectChildValueCheckboxExpanded: selectChildValueCheckboxExpanded,
                      multiselection: handleChildValueSelect,
                      selectChildValue: selectChildValue,
                      validator: validator,
                      showValidationMessage: showValidationMessage,
                      thData: props.pageLayoutData.thData,
                      tdData: props.pageLayoutData.tdData,
                      setImageSize: setImageSize,
                      imageSize: imageSize,
                      setImageData: setImageData,
                      setImageBinary: setImageBinary,
                      imagePath: props.imagePath,
                      duplicateCheck: duplicateCheck,
                      setDuplicateCheck: setDuplicateCheck,
                      parentTableLength: parentTableLength,
                      setParentTableLength: setParentTableLength,
                      setSelectedCombo : setSelectedCombo,
                      setHasError: setHasError,
                      // backCheck: props.backCheck,
                      // setBackCheck: props.setBackCheck,
                      // backButtonItems: props.backButtonItems
                     // backCheck: backCheck
                    })
                  :
                  React.createElement(
                    () => <div>The component {block.component} has not been created yet.</div>,
                    { key: block.id }
                  )
                )
              )}   
                <Row key="MDBROW1"></Row>
                <Row key="MDBROW2"></Row> 
               </Modal.Body>         
              <div style={{marginBottom:'100px'}}>
                <Row className='d-flex align-items-center mb-4'>
                  <div className='modal__button-container'>
                    {previousButton()}
                    {nextButton()}
                  </div>
                </Row>
              </div>
              </div>
              {isLoader===true&&<div className="beat-loader" ><BeatLoader  color={"#3C423C"} /></div>}
          {/* <Card
            title={
            
            }
            content={
            <>
             
            {/* <Row style={{ float: 'right',marginBottom:'5px',marginRight:'5px'}}> */}
                                {/* {(props.pageLayoutData1.addButton1 === true) ? <ButtonField color="info" submit={() => openLocation()} BName={'Add '+ props.pageLayoutData1.addButtonName1} /> : ''}
                                {(props.pageLayoutData1.addButton2 === true) ? <ButtonField color="info" submit={() => openBusinessUnit()} BName={'Add '+ props.pageLayoutData1.addButtonName2} /> : ''}
                                {(props.pageLayoutData1.addButton3 === true) ? <ButtonField color="info" submit={() => openUOM()} BName={'Add '+ props.pageLayoutData1.addButtonName3} /> : ''} */}
                                {/* {showModal ?
                                  <ModalBox
                                    key={ props.pageLayoutData.featureId }
                                    showModal={showModal}
                                    titlePreFix = { modalType }
                                    title={ modalTitle }
                                    formValue={ ModalformValues }
                                    addURL={ modalActionURL }
                                    modalWidth = { modalWidth}
                                    recallMehod= { props.recallMethod }
                                   // stepFormValues = {props.pageLayoutData.content.steps}
                                    setFormValues = {setFormValues}
                                    formValues= {formValues}
                                    drpdwnApi = {props.locationDropDownAPI }
                                    businessNewDropdownApi = {props.pageLayoutData2.hasOwnProperty('newBusinessUnitEndPoint') ? props.pageLayoutData2.newBusinessUnitEndPoint : 'not found' }
                                  //    getURL={ modalgetURL }
                                    hide={close} />
                                  : ''} */}
              {/* </Row> */}


           
        </Col>
      </Row>
    </Grid>
    </div>
   : <div><BeatLoader size={15} margin={3} color={"#36d7b7"} /></div>
  );
}



export default RoleWizard;
